import { render, staticRenderFns } from "./companySetting.vue?vue&type=template&id=6b3d6902&lang=pug"
import script from "./companySetting.vue?vue&type=script&lang=js"
export * from "./companySetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports